module.exports = __webpack_public_path__ + "img/maestro-old.8f118064.svg";